import {
  InsuranceTypeEnum,
  QuotationStatusEnum,
  VehicleTypeEnum,
} from 'app/shared/enums';
import { QuotationState } from 'app/store/data/quotation';

export const botQuotation: QuotationState = {
  id: '9722ee25-9c61-4072-a448-b00589eddc12',
  userId: '77608a28-f9f7-4a82-9e43-72ca541dbbcd',
  number: 'NJLKK8A',
  status: QuotationStatusEnum.Created,
  activeABTests: [],
  vehicleType: VehicleTypeEnum.Car,
  scope: {
    components: [InsuranceTypeEnum.Oc],
  },
  coOwners: [],
  additionalDrivers: [],
  renewal: false,
  externalRenewal: false,
  shortPath: null,
  cepikMergeResult: null,
};
